class ThirdPartyLinkNewTab{
  constructor(contentElements) {
      try {
        this.contentElements = contentElements;
        this.contentLinks = [];

        this.contentElements.forEach((element) => {
          let links = element.querySelectorAll('a');
          links.forEach((element) => {
            this.contentLinks.push(element);
          });
        });

        this.contentLinks.forEach((link) => {
          link.addEventListener("click", () => this.openNewTabExt(link));
        });
      }catch (error) {
          console.log(error);
      }
  }
  openNewTabExt = (link) => {
    let url = link.getAttribute('href');
    if(url.includes('http') && !url.includes('scottdunn')){
      link.setAttribute('target', '_blank');
      window.open(url);
    }
  }
}

export default ThirdPartyLinkNewTab;